var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}.e{fill:#888;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 32,
    height: 32,
    rx: 5.51,
    ry: 5.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 7.41,
    y: 7.5,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 13.8,
    y: 7.5,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 20.19,
    y: 7.5,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 7.41,
    y: 13.8,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 13.8,
    y: 13.8,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 20.19,
    y: 13.8,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 7.41,
    y: 20.09,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 13.8,
    y: 20.09,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 20.19,
    y: 20.09,
    width: 4.41,
    height: 4.41,
    rx: 0.77,
    ry: 0.77
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsDefault);
export default __webpack_public_path__ + "static/media/appsDefault.2d9ffd3fad64fc544270fbbfe09ad10f.svg";
export { ForwardRef as ReactComponent };